// extracted by mini-css-extract-plugin
export default {"outcomeMain":"MarketOutcomeContainer_outcomeMain--ZKQ","table":"MarketOutcomeContainer_table--GeL","outcomeContainer":"MarketOutcomeContainer_outcomeContainer--tKw"};